import { render, staticRenderFns } from "./MultiAccount.vue?vue&type=template&id=228befde&scoped=true"
import script from "./MultiAccount.vue?vue&type=script&lang=js"
export * from "./MultiAccount.vue?vue&type=script&lang=js"
import style0 from "./MultiAccount.vue?vue&type=style&index=0&id=228befde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228befde",
  null
  
)

export default component.exports